class ReviewsCarousel extends HTMLElement {
  connectedCallback() {
    this.scroller = this.querySelector('.reviews');
    this.prevButton = this.querySelector('.reviews__arrow--prev');
    this.nextButton = this.querySelector('.reviews__arrow--next');
    if (!this.scroller) return;

    this.update = this.update.bind(this);

    this.prevButton?.addEventListener('click', () => this.scrollByCards(-1));
    this.nextButton?.addEventListener('click', () => this.scrollByCards(1));
    this.scroller.addEventListener('scroll', this.update, { passive: true });

    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.scroller);
    } else {
      window.addEventListener('resize', this.update);
    }

    this.update();
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    window.removeEventListener('resize', this.update);
  }

  /** Width of one card including the flex gap. */
  cardStep() {
    const card = this.scroller.querySelector('review-card');
    const styles = getComputedStyle(this.scroller);
    const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
    if (card) return card.getBoundingClientRect().width + gap;
    return this.scroller.clientWidth * 0.8;
  }

  scrollByCards(direction) {
    this.scroller.scrollBy({ left: direction * this.cardStep(), behavior: 'smooth' });
  }

  update() {
    const { scrollLeft, scrollWidth, clientWidth } = this.scroller;
    const maxScroll = scrollWidth - clientWidth;
    // Disabled controls are hidden via CSS, so this also hides both when the
    // content isn't scrollable at all.
    if (this.prevButton) this.prevButton.disabled = scrollLeft <= 1;
    if (this.nextButton) this.nextButton.disabled = scrollLeft >= maxScroll - 1;
  }
}

if (!customElements.get('reviews-carousel')) {
  customElements.define('reviews-carousel', ReviewsCarousel);
}
